import { ref } from "vue";

// =======================
// CONSENT STATE
// =======================
export const cookieConsent = ref({
  required: true,
  statistik: false,
  marketingGoogle: false,
  marketingLinkedIn: false,
  accepted: false,
});

// =======================
// FLAGS
// =======================
let trackingLoaded = false;
let linkedinLoaded = false;
let pageViewSent = false;

//const GA_ID = "G-48DDR3M34T";
const GA_ID = "G-SDPEJYTJBY";
const ADS_ID = "AW-1068722812";

const ALLOWED_PATHS = ["/itberatung", "/kontaktform"];
function isAllowedPage(path = window.location.pathname) {
  const clean = path.split(/[?#]/)[0].replace(/\/+$/, "");
  return ALLOWED_PATHS.includes(clean);
}
// =======================
// LOAD GTAG (ONCE)
// gtag wird SOFORT definiert (Standard-Methode von Google).
// Befehle landen in der dataLayer-Queue, bis das Script geladen ist.
// So geht der erste page_view nicht mehr verloren.
// =======================
function loadGtag() {
  if (trackingLoaded) return;
  trackingLoaded = true;
 
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  configureGoogle();
 
  const script = document.createElement("script");
  script.async = true;
  script.src =
    "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
  script.onload = () => {
    console.log("GA loaded");
  };
  document.head.appendChild(script);
 
  // erste Seitenansicht sicher senden (pageViewSent verhindert Duplikate)
  trackPageView();
}

// =======================
// CONFIGURE GA + ADS (SEPARATE)
// =======================
function configureGoogle() {
  if (typeof window.gtag !== "function") return;

  // GA4
  if (cookieConsent.value.statistik) {
    window.gtag("config", GA_ID, {
      send_page_view: false,
      anonymize_ip: true,
    });
  }

  // Google Ads
  if (cookieConsent.value.marketingGoogle) {
    window.gtag("config", ADS_ID);
  }

}

// =======================
// LINKEDIN
// =======================
function loadLinkedIn() {
  if (linkedinLoaded) return;
  linkedinLoaded = true;

  window._linkedin_partner_id = "9195570";

  window._linkedin_data_partner_ids =
    window._linkedin_data_partner_ids || [];

  window._linkedin_data_partner_ids.push(
    window._linkedin_partner_id
  );

  // ✅ FIXED safe queue
  window.lintrk = window.lintrk || function () {
    (window.lintrk.q = window.lintrk.q || []).push(arguments);
  };

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src =
    "https://snap.licdn.com/li.lms-analytics/insight.min.js";

  document.head.appendChild(script);

  console.log("LinkedIn Insight loaded");
}

// =======================
// PAGE VIEW (NO DUPLICATE)
// =======================
export function trackPageView(toPath) {
  const path = toPath || window.location.pathname;
 if (!isAllowedPage(path)) return;
  if (!cookieConsent.value.statistik) return;
  if (!window.gtag) return;
 if (pageViewSent) return;
  pageViewSent = true;

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_path: path,
    page_location: window.location.href,
  });
}

// =======================
// RESET (IMPORTANT FOR SPA)
// =======================
export function resetPageViewFlag() {
  pageViewSent = false;
}

// =======================
// MAIN ACTIVATION
// =======================
export function activateTrackingScripts(route) {
  if (typeof window === "undefined") return;

   // nur itberatung and kontaktform
   const path = (route?.path || window.location.pathname).replace(/\/+$/, "");

    if (!isAllowedPage(path)) return;
  if (!cookieConsent.value.accepted) return;

  // GOOGLE
  if (
    cookieConsent.value.statistik ||
    cookieConsent.value.marketingGoogle
  ) {
    loadGtag();
  }

  // LINKEDIN
  if (cookieConsent.value.marketingLinkedIn) {
    loadLinkedIn();
  }
}
// =======================
//  GOOGLE ADS CONVERSION TRACKING
// =======================
export function trackGoogleAdsConversion() {
  if (!cookieConsent.value.marketingGoogle) return;
  if (typeof window.gtag !== "function") return;
  if (!isAllowedPage()) return; //nur in itberatung und kontaktform

  window.gtag("event", "conversion", {
    send_to: "AW-1068722812/XQ_DCIql9K8cEPzUzf0D", //Verify this from Google Ads
  });
}
export function saveConsentToCookie(statistik, google, linkedin) {
  const data = {
    statistik,
    marketingGoogle: google,
    marketingLinkedIn: linkedin,
  };

  localStorage.setItem("cookieConsent", JSON.stringify(data));

  cookieConsent.value = {
    required: true,
    accepted: true,
    ...data,
  };
}
export function loadConsentFromCookie() {
  const data = localStorage.getItem("cookieConsent");
  if (!data) return null;

  const parsed = JSON.parse(data);

   cookieConsent.value = {
    required: true,
    accepted: true,
    ...parsed,
  };
  return parsed;
}
